import React from "react";
import "./TryAtHomeSection.css";
import Tah from "../Images/Tah.jpg";
import spinelle from "../Images/spinelle.avif";

const TryAtHomeSection = () => {
  return (
    <section className="try-at-home">
      <div className="try-at-home-container">
        <div className="try-image-wrapper">
          <img src={Tah} alt="Try at Home" className="main-image" />
          <img src={spinelle} alt="Spinelle Logo" className="logo-overlay" />
        </div>
        <div className="try-content">
         
          <h3>NOW INTRODUCING</h3>
          <h1>Try at Home!</h1>
          <p>
            We live in a world of convenience.<br /><br />
            From clothing subscriptions to online workouts, everything is just a click away. Now, you can add fine jewelry to that list — with Spinelle’s new Try At Home experience.
          </p>
          <p className="contact-info">
            ✉️ <strong>info@spinelle.in</strong><br />
            📞 <strong>+91 99664 77192</strong><br />
    
          </p>
          <button className="book-now-btn">Book Now</button>
        </div>
      </div>
    </section>
  );
};

export default TryAtHomeSection;
